import type { RepositoryConfig } from "gatsby-plugin-prismic-previews";

import Homepage from "../pages/index";
import Page from "templates/Page";

import linkResolver from "utils/linkResolverTypeScript";

const repositoryName = process.env.GATSBY_PRISMIC_REPO_NAME;

if (!repositoryName) {
  throw new Error("GATSBY_PRISMIC_REPO_NAME is not set");
}

export const repositoryConfigs: RepositoryConfig[] = [
  {
    repositoryName,
    linkResolver,
    componentResolver: {
      homepage: Homepage,
      page: Page,
    },
  },
];
